<template>
    <div class="bg_F9F8F7">
        <nav-bar />
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">

</style>